import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import EnvironmentSettings from "../Models/EnvironmentSettings";
import UsersApi from "Classes/API/UsersApi";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import TenantManager from "./TenantManager";

class AccountingApi {
  constructor() {
    EnvironmentSettings.Environment === "dev"
      ? (this.baseUrl = EnvironmentSettings.LocalUrl)
      : (this.baseUrl = EnvironmentSettings.LiveUrl);
  }

  ExportPackageReportUrl = "Accounting/ExportPackageReport";
  GetLastPackageDetailsUrl = "Accounting/GetLastPackageDetails";
  DeleteAllPackageSessionsUrl = "Accounting/DeleteAllPackageSessions";
  GetUserNotificationsUrl = "Accounting/GetUserNotifications";
  SearchLogsUrl = "Accounting/SearchLogs";
  TogglePackagePostPaidUrl = "Accounting/TogglePackagePostPaid";
  SetPackagePostPaidPercentageUrl = "Accounting/SetPackagePostPaidPercentage";
  GetAccSessionsPackagesStatistics =
    "Accounting/GetAccSessionsPackagesStatistics";
  GetAccSessionsPackagesStatistics =
    "Accounting/GetAccSessionsPackagesStatistics";
  GetAccountingEntryStatisticsUrl = "Accounting/GetAccountingEntryStatistics";
  ExportAccountingSessionsToExcelUrl =
    "Accounting/ExportAccountingSessionsToExcel";
  GetAccountingSessionsForExportUrl =
    "Accounting/GetAccountingSessionsForExport";
  GetPatientProgramDetailsUrl = "Accounting/GetPatientProgramDetails";

  async GetPatientProgramDetails(patientId) {
    const res = await fetch(this.baseUrl + this.GetPatientProgramDetailsUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(patientId),
    });
    let data = await res.json();
    return data;
  }

  async GetLastPackageDetails(patientId) {
    const res = await fetch(this.baseUrl + this.GetLastPackageDetailsUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(patientId),
    });
    let data = await res.json();
    return data;
  }
  async GetAccountingSessionsForExport(req) {
    let url = this.baseUrl + this.GetAccountingSessionsForExportUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }
  async ExportAccountingSessionsToExcel(req) {
    let url = this.baseUrl + this.ExportAccountingSessionsToExcelUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.blob();
    return data;
  }

  //GetAccountingEntryStatistics
  async GetAccountingEntryStatistics(req) {
    let url = this.baseUrl + this.GetAccountingEntryStatisticsUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }
  async GetPackagesStatistics(req) {
    let url = this.baseUrl + this.GetAccSessionsPackagesStatistics;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async SetPackagePostPaidPercentage(req) {
    const res = await fetch(
      this.baseUrl + this.SetPackagePostPaidPercentageUrl,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${await UsersApi.GetToken()}`,
          tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        },
        body: JSON.stringify(req),
      },
    );
    let data = await res.json();
    return data;
  }

  async TogglePackagePostPaid(req) {
    const res = await fetch(this.baseUrl + this.TogglePackagePostPaidUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await res.json();
    return data;
  }

  async ExportPackageReport(req) {
    let url = this.baseUrl + this.ExportPackageReportUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.blob();
    return data;
  }

  async SearchLogs(req) {
    const res = await fetch(this.baseUrl + this.SearchLogsUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    const data = await res.json();
    return data;
  }

  async GetUserNotifications(req) {
    const res = await fetch(this.baseUrl + this.GetUserNotificationsUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    const data = await res.json();
    return data;
  }

  async DeleteAllPackageSessions(req) {
    let url = this.baseUrl + this.DeleteAllPackageSessionsUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  //******************PAY From BALANCE*****************************************/

  PayFromBalanceUrl = "Accounting/PayFromBalance";

  async PayFromBalance(req) {
    let url = this.baseUrl + this.PayFromBalanceUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  // ******************Contracts*****************************************/
  CreateContractUrl = "Accounting/CreateContract";
  GetContractByIdUrl = "Accounting/GetContractById";
  DeleteContractUrl = "Accounting/DeleteContract";
  GetUnlinkedSessionsUrl = "Accounting/GetUnlinkedSessions";
  GetContractReportUrl = "Accounting/GetContractReport";
  AddSessionToContractUrl = "Administration/AddSessionToContract";
  EditContractUrl = "Accounting/EditContract";
  SearchContractsUrl = "Accounting/SearchContracts";
  AddPatientToContractUrl = "Accounting/AddPatientToContract";
  RemovePatientFromContractUrl = "Accounting/RemovePatientFromContract";

  async CreateContract(req) {
    let url = this.baseUrl + this.CreateContractUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async GetContractById(req) {
    let url = this.baseUrl + this.GetContractByIdUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async DeleteContract(req) {
    let url = this.baseUrl + this.DeleteContractUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async SearchContracts(req) {
    let url = this.baseUrl + this.SearchContractsUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async GetUnlinkedSessions(req) {
    let url = this.baseUrl + this.GetUnlinkedSessionsUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }
  async GetContractReport(req) {
    let url = this.baseUrl + this.GetContractReportUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async downloadContractReportCSV(data) {
    if (!data || !data.data) {
      console.error("Invalid data received");
      return;
    }

    const worksheetData = [
      [
        "Patient Name",
        "Session Name",
        "Total Sessions",
        "Price per session",
        "Total Price",
        "Total Amount",
      ],
    ];

    data.data.forEach((patient) => {
      patient.patientSessions.forEach((session) => {
        let firstRow = true;

        session.priceDetails.forEach((priceDetail) => {
          const formattedPrice =
            priceDetail.count > 1
              ? `${priceDetail.pricePerSession} x(${priceDetail.count})`
              : priceDetail.pricePerSession;

          worksheetData.push([
            firstRow ? patient.patientName : "",
            firstRow ? session.sessionName : "",
            firstRow ? session.quantity : "",
            formattedPrice,
            firstRow ? session.totalPrice : "",
            firstRow ? patient.totalAmount : "",
          ]);
          firstRow = false;
        });
      });
    });

    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    ws["!cols"] = [
      { wch: 20 }, // Patient Name
      { wch: 25 }, // Session Name
      { wch: 25 }, // Total Sessions
      { wch: 18 }, // Price Per Session
      { wch: 15 }, // Total Price
      { wch: 15 }, // Total Amount
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Contract Report");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(excelData, "Contract_Report.xlsx");
  }

  async EditContract(req) {
    let url = this.baseUrl + this.EditContractUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();

    console.log(data);
    return data;
  }

  async AddPatientToContract(req) {
    let url = this.baseUrl + this.AddPatientToContractUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  async RemovePatientFromContract(req) {
    let url = this.baseUrl + this.RemovePatientFromContractUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    console.log(data);
    return data;
  }

  // ******************DomesticStays*****************************************/

  GetDomesticStayByIdUrl = "Accounting/GetDomesticStayById";
  ToggleDomesticStayActivationUrl = "Accounting/ToggleDomesticStayActivation";
  ToggleDomesticStayCalculationUrl = "Accounting/ToggleDomesticStayCalculation";
  SearchDomesticStaysUrl = "Accounting/SearchDomesticStays";
  UseAmountForDomesticStayUrl = "Accounting/UseAmountForDomesticStay";
  PayAmountForDomesticStayUrl = "Accounting/PayAmountForDomesticStay";
  CreateDomesticStayUrl = "Accounting/CreateDomesticStay";
  EditDomesticStayUrl = "Accounting/EditDomesticStay";
  AddExtraToDomesticStayUrl = "Accounting/AddExtraToDomesticStay";
  RemoveExtraFromDomesticStayUrl = "Accounting/RemoveExtraFromDomesticStay";
  EditDomesticStayExtraUrl = "Accounting/EditDomesticStayExtra";
  AddAccountingSessionToDomesticStayUrl =
    "Accounting/AddAccountingSessionToDomesticStay";
  RemoveAccountingSessionFromDomesticStayUrl =
    "Accounting/RemoveAccountingSessionFromDomesticStay";

  AddExtraAccountingSessionToDomesticStayUrl =
    "Accounting/AddExtraAccountingSessionToDomesticStay";
  RemoveExtraAccountingSessionFromDomesticStayUrl =
    "Accounting/RemoveExtraAccountingSessionFromDomesticStay";
  CalculateDomesticStaySessionsPriceUrl =
    "Accounting/CalculateDomesticStaySessionsPrice";

  SearchPatientAnalysisUrl = "Accounting/SearchPatientAnalysis";

  async SearchPatientAnalysis(req) {
    let url = this.baseUrl + this.SearchPatientAnalysisUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async CalculateDomesticStaySessionsPrice(req) {
    let url = this.baseUrl + this.CalculateDomesticStaySessionsPriceUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }
  async GetDomesticStayById(req) {
    let url = this.baseUrl + this.GetDomesticStayByIdUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async ToggleDomesticStayActivation(req) {
    let url = this.baseUrl + this.ToggleDomesticStayActivationUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async ToggleDomesticStayCalculation(req) {
    let url = this.baseUrl + this.ToggleDomesticStayCalculationUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async SearchDomesticStays(req) {
    let url = this.baseUrl + this.SearchDomesticStaysUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async UseAmountForDomesticStay(req) {
    let url = this.baseUrl + this.UseAmountForDomesticStayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async PayAmountForDomesticStay(req) {
    let url = this.baseUrl + this.PayAmountForDomesticStayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async CreateDomesticStay(req) {
    let url = this.baseUrl + this.CreateDomesticStayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async EditDomesticStay(req) {
    let url = this.baseUrl + this.EditDomesticStayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async AddExtraToDomesticStay(req) {
    let url = this.baseUrl + this.AddExtraToDomesticStayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async RemoveExtraFromDomesticStay(req) {
    let url = this.baseUrl + this.RemoveExtraFromDomesticStayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async EditDomesticStayExtra(req) {
    let url = this.baseUrl + this.EditDomesticStayExtraUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async AddAccountingSessionToDomesticStay(req) {
    let url = this.baseUrl + this.AddAccountingSessionToDomesticStayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async RemoveAccountingSessionFromDomesticStay(req) {
    let url = this.baseUrl + this.RemoveAccountingSessionFromDomesticStayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async AddExtraAccountingSessionToDomesticStay(req) {
    let url = this.baseUrl + this.AddExtraAccountingSessionToDomesticStayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async RemoveExtraAccountingSessionFromDomesticStay(req) {
    let url =
      this.baseUrl + this.RemoveExtraAccountingSessionFromDomesticStayUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  // ************************ Accounting **************************** */
  RefundUrl = "Accounting/Refund";
  CreateAccountingEntryUrl = "Accounting/CreateAccountingEntry";
  DeleteAccountingEntryUrl = "Accounting/DeleteAccountingEntry";
  EditAccountingEntryUrl = "Accounting/EditAccountingEntry";
  SearchAccountingEntryUrl = "Accounting/SearchAccountingEntry";
  SearchAllBalancesUrl = "Accounting/SearchAllBalances";

  ExportEntriesToExcelUrl = "Accounting/ExportEntriesToExcel";
  SearchAccountingTherapistHour = "Accounting/SearchAccountingTherapistHour";
  FindAccountingSessionPatientEnteriesUrl =
    "Accounting/FindAccountingSessionPatientEnteries";

  GetCurrentUserBalanceUrl = "Accounting/GetCurrentUserBalance";
  PayFromUserBalanceForPackageUrl = "Accounting/PayFromUserBalanceForPackage";
  PrintPackageSummaryUrl = "Accounting/PrintPackageSummary";

  TransferRefundableAmountToUserBalanceUrl =
    "Accounting/TransferRefundableAmountToUserBalance";
  TransferAvailablePackageBalanceToUserBalanceUrl =
    "Accounting/TransferAvailablePackageBalanceToUserBalance";
  RefundRefundableAmountUrl = "Accounting/RefundRefundableAmount";
  RefundAvailableAmountUrl = "Accounting/RefundAvailableAmount";

  ArchiveContractUrl = "Accounting/ArchiveContract";
  UnArchiveContractUrl = "Accounting/UnArchiveContract";

  DeleteContractUrl = "Accounting/DeleteOneContract";

  async UnarchiveContract(contractId) {
    let url = this.baseUrl + this.UnArchiveContractUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(contractId),
    });
    let data = await response.json();
    return data;
  }

  async ArchiveContract(contractId) {
    let url = this.baseUrl + this.ArchiveContractUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(contractId),
    });
    let data = await response.json();
    return data;
  }

  // Delete Contract method
  async DeleteContract(contractId) {
    let url = this.baseUrl + this.DeleteContractUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(contractId),
    });
    let data = await response.json();
    return data;
  }

  async Refund(req) {
    let url = this.baseUrl + this.RefundUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async RefundAccSession(req) {
    let url = this.baseUrl + this.RefundUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async ExportEntriesToExcel(req) {
    let url = this.baseUrl + this.ExportEntriesToExcelUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.blob();
    return data;
  }

  async SearchAllBalances(req) {
    let url = this.baseUrl + this.SearchAllBalancesUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async FindAccountingSessionPatientEnteries(req) {
    let url = this.baseUrl + this.FindAccountingSessionPatientEnteriesUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async SearchAccountingEntries(req) {
    let url = this.baseUrl + this.SearchAccountingEntryUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }
  async DeleteAccountingEntries(req) {
    let url = this.baseUrl + this.DeleteAccountingEntryUrl;
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (await UsersApi.GetToken()),
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(req),
    });
    let data = await response.json();
    return data;
  }

  async CreateAccountingEntry(req) {
    const res = await fetch(this.baseUrl + this.CreateAccountingEntryUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    return data;
  }

  async EditAccountingEntry(req) {
    const res = await fetch(this.baseUrl + this.EditAccountingEntryUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    return data;
  }

  async accountingTherapistHourId(req) {
    const res = await fetch(this.baseUrl + this.SearchAccountingTherapistHour, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    return data;
  }

  async GetCurrentUserBalance(req) {
    const res = await fetch(this.baseUrl + this.GetCurrentUserBalanceUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    return data;
  }

  async PayFromUserBalanceForPackage(req) {
    const res = await fetch(
      this.baseUrl + this.PayFromUserBalanceForPackageUrl,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${await UsersApi.GetToken()}`,
          tenant: TenantManager.getTenant(await UsersApi.GetToken()),
          "Content-type": "application/json",
        },
        body: JSON.stringify(req),
      },
    );

    const data = await res.json();
    return data;
  }

  async transferRefundableAmount(req) {
    const res = await fetch(
      this.baseUrl + this.TransferRefundableAmountToUserBalanceUrl,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${await UsersApi.GetToken()}`,
          tenant: TenantManager.getTenant(await UsersApi.GetToken()),
          "Content-type": "application/json",
        },
        body: JSON.stringify(req),
      },
    );

    const data = await res.json();
    return data;
  }

  async transferAvailableAmount(req) {
    const res = await fetch(
      this.baseUrl + this.TransferAvailablePackageBalanceToUserBalanceUrl,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${await UsersApi.GetToken()}`,
          tenant: TenantManager.getTenant(await UsersApi.GetToken()),
          "Content-type": "application/json",
        },
        body: JSON.stringify(req),
      },
    );

    const data = await res.json();
    return data;
  }
  async refundRefundableAmount(req) {
    const res = await fetch(this.baseUrl + this.RefundRefundableAmountUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    return data;
  }

  async refundAvailableAmount(req) {
    const res = await fetch(this.baseUrl + this.RefundAvailableAmountUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    return data;
  }
  async refundRefundableAmount(req) {
    const res = await fetch(this.baseUrl + this.RefundRefundableAmountUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    return data;
  }

  async refundAvailableAmount(req) {
    const res = await fetch(this.baseUrl + this.RefundAvailableAmountUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    return data;
  }

  async PrintPackageSummary(packageId) {
    try {
      const url = this.baseUrl + this.PrintPackageSummaryUrl;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${await UsersApi.GetToken()}`,
          tenant: TenantManager.getTenant(await UsersApi.GetToken()),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(packageId),
      });

      if (!response.ok) {
        throw new Error("Failed to download package summary PDF (HTTP Error)");
      }

      const jsonResponse = await response.json();

      if (jsonResponse.status !== "Success" || !jsonResponse.data) {
        throw new Error(
          jsonResponse.message || "PDF generation failed on server.",
        );
      }

      const base64Data = jsonResponse.data;

      const blob = this.b64toBlob(base64Data, "application/pdf");

      return blob;
    } catch (error) {
      console.error("Error downloading package summary:", error);
      throw error;
    }
  }

  b64toBlob(b64Data, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}

export default new AccountingApi();
